// src/components/Service.jsx
import React from 'react';
import '../css/Service.css';
import { FaLaptopCode, FaMobileAlt, FaCashRegister, FaNetworkWired } from 'react-icons/fa';

const Service = () => {
  return (
    <section className="services" id="services">
      <div className="services-container">
        <h2 className="section-title">Our Services</h2>
        <div className="service-list">
          <div className="service-card">
            <FaLaptopCode className="service-icon" />
            <h3>Web Development</h3>
            <p>Scalable and responsive websites built using modern frameworks tailored to your needs.</p>
          </div>
          <div className="service-card">
            <FaMobileAlt className="service-icon" />
            <h3>Mobile App Development</h3>
            <p>Cross-platform mobile apps for iOS and Android that offer high performance and sleek UX.</p>
          </div>
          <div className="service-card">
            <FaCashRegister className="service-icon" />
            <h3>POS Systems</h3>
            <p>Customizable Point-of-Sale systems to streamline retail and F&B operations efficiently.</p>
          </div>
          <div className="service-card">
            <FaNetworkWired className="service-icon" />
            <h3>Network / CCTV / PABX</h3>
            <p>End-to-end setup of office network infrastructure, surveillance, and communication systems.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
